<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">

        <div class="container pt-3">
            <ButtonTag
                :is-tw-main-btn="true"
                url="addSaleRefund"
                :is-w100="false"
            >
                <div class="pt-1">
                    {{ $t('returnProducts.newReturn') }}
                </div>
            </ButtonTag>
        </div>


        <table class="w-full mt-3" v-if="hasRefundSale">
                <thead class="bg-lightGray h-11 font-bold">
                <tr>
                    <th class="d-none d-lg-table-cell pl-3">{{ $t('printView.receipt') }}</th>
                    <th>{{ $t('returnProducts.returnDate') }}</th>
                    <th>{{ $t('customer.title') }}</th>
                    <th class="d-none d-lg-table-cell">{{ $t('returnProducts.returnAmount') }}</th>
                    <th class="d-none d-md-table-cell">{{ $t('price') }}</th>
                    <th>{{ $t('detailed') }}</th>
                </tr>
                </thead>
                <tbody
                    v-for="item in getRefundSales"
                    :key="item.id"
                >
                <tr class="cursor-pointer h-11">
                    <td class="d-none d-lg-table-cell pl-3">{{ item.sale.id }}</td>
                    <td>{{ dateTimeFormat(item.createdAt, false)}}</td>
                    <td>
                        {{getCustomerName(item)}}
                    </td>
                    <td class="d-none d-md-table-cell text-center">
                        {{item.refundAmount}} {{ $t('returnProducts.type') }}
                    </td>
                    <td class="d-none d-md-table-cell">
                        {{showCurrencyById(item.refundPriceCurrency.id, item.refundPrice)}}
                    </td>
                    <td @click="showOneRefundSale(item)">
                       <img src="/images/read-more.png" alt="" class="h-7">
                    </td>
                </tr>
                </tbody>
            </table>

        <RowColumn v-if="hasRefundSale" class="ml-2 mt-3">
            <Pagination
                :search="search"
                base-url="saleRefund"
                :total-items="getRefundSalesTotalCount"
                method-name="fetchSaleRefunds"/>
        </RowColumn>
    </Row>
</template>

<script>
import currencyFormat from "../../mixin/currencyFormatMixin";
import Row from "../../components/html/Row";
import RowColumn from "../../components/RowColumn";
import {mapActions, mapGetters} from "vuex";
import accessMixin from "@/mixin/accessMixin";
import ButtonTag from "@/components/html/ButtonTag";
import dateFormatting from "@/mixin/dateFormattingMixin";
import Pagination from "@/components/html/Pagination";

export default {
    name: "SaleRefundList",
    components: {
        Pagination,
        ButtonTag,
        RowColumn,
        Row,
    },
    mixins: [currencyFormat, accessMixin, dateFormatting],
    data() {
        return {
            search: {
                page: 1,
            },
            hasRefundSale: false,
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'returnProducts.return'},
            ],
        }
    },
    computed: mapGetters(['getRefundSales', 'getRefundSalesTotalCount']),
    methods: {
        ...mapActions(['fetchSaleRefunds', 'setBreadcrumbItems']),
        getCustomerName(item) {
            return item.customer.isCompany ?
                item.customer.customerCompany.name :
                item.customer.person.givenName + ' ' + item.customer.person.familyName
        },
        showOneRefundSale(saleRefund) {
            this.$i18nHelper.toUrl('saleRefund/' + saleRefund.sale.id)
        }
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        this.$root.showOverlay = true

        this.fetchSaleRefunds(this.search)
            .then(() => {
                this.hasRefundSale = true
                this.$root.showOverlay = false
            })
    },
}
</script>

<style scoped>

table tbody tr {
    border-bottom: 1px solid #eaeaea;
}

</style>